$(document).ready(function(){
  setTimeout(function() {
    $("#mobile_nav .slicknav_nav").find("a.sub-menu--link").click(function(e){
      e.preventDefault();
  
      $(this).next("a.slicknav_item").trigger("click");
    })  
  }, 3000); // 2000ms = 2s


  function checkScroll() {
      if ($(window).scrollTop() > 50) {
          $('.header-container').addClass('shrink');
      } else {
          $('.header-container').removeClass('shrink');
      }
  }
  
  // Run when page loads
  $(document).ready(function() {
      checkScroll();
  });
  
  // Run when user scrolls
  $(window).on('scroll', function() {
      checkScroll();
  });
})
